import { render, staticRenderFns } from "./StatusChangeModal.vue?vue&type=template&id=ec4103d4&"
import script from "./StatusChangeModal.vue?vue&type=script&lang=js&"
export * from "./StatusChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports